import { notification } from 'antd';
import moment from 'moment';
import { captureError } from '../pages/captureError';
import { getPtFullName, getPtFullNameWithSalutation, Patient } from '../store/types/patient';
import { getAgeString } from '../store/utils';
import { getPatientByLocalId } from '../store/idbHandler';

let script: HTMLScriptElement | undefined;

export const setupBarcode = (): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
        if (!script) {
            const element = document.querySelector('body');
            script = document.createElement('script');
            script.src = '/barcode/barcode_setup.js';
            script.onload = () => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // setup_web_print();
                resolve();
            };
            element?.appendChild(script);

            return;
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setup_web_print();
        resolve();
    });
};

const getPrintString = (patient: Patient): string => {
    const uhid = patient.formData?.find((t) => t.key === 'uhid')?.value;
    const data = `^XA
        ^FS^CFA,20^FO80,100,^A0N,50,30,
        ^FD${getPtFullNameWithSalutation(patient)}${uhid ? ` - ${uhid}` : ''}
        ^FS^FO80,160,^A0N,25,25
        ^FD${getAgeString(
            {
                age: patient.personal.age?.value,
                month: patient.personal.age?.month,
                dob: patient.personal.age?.dob,
            },
            '',
            ' /',
        )} ${patient.personal.gender.toUpperCase()} 
        ^FS^FO340,160,^A0N,25,25
        ^FD${moment(patient.createdAt).format('DD/MM/YYYY HH:mm')}
        ^FS^FO80,200,^A0N,35,30
        ^FD${patient.personal.phone?.n || ''}
        ^FS
        ^FO80,240,
        ^A0N,25,20
        ^FB550,4
        ^FD${patient.formData
            ?.filter((t) => t.value && t.key !== 'uhid' && t.key !== 'salutation')
            .map((t) => t.label + ': ' + t.value)
            .join(' | ')}
        ^FS
        ^XZ`;
    return data;
};

export const printLabelForPatientWithId = async (id: string): Promise<void> => {
    const patient = await getPatientByLocalId(id);
    if (patient) {
        return printLabelForPatient(patient);
    }
    notification.error({
        message: 'Patient not found',
        duration: 5,
    });
};

window.printLabelForPatientWithId = printLabelForPatientWithId;

export const printLabelForPatient = (p: Patient): Promise<void> => {
    return new Promise((resolve, reject) => {
        try {
            const str = getPrintString(p);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            sendData(str);
            notification.success({
                message: 'Label printed successfully',
                duration: 5,
            });
        } catch (e) {
            notification.error({
                message: 'Error printing label, please check printer status',
                duration: 5,
            });
            console.error(e);
            captureError(e as Error);
        }
        resolve();
    });
};
